import { Environment } from '../environment/environment';

export class CurrentPage {
    public static isGamePage() {
        return window && typeof window.isGamePageFlag !== 'undefined' && window.isGamePageFlag === true;
    }

    public static reload() {
        if (Environment.isLanding() || Environment.isSite()) {
            location.reload();
        } else {
            top.location.href = window.app.config.app_url + window.app.config.social_app_id;
        }
    }

    public static setLoadingState() {
        $(document.body).addClass('cursorprogress');
    }

    public static disableLoadingState() {
        $(document.body).removeClass('cursorprogress');
    }
}
